// src/App.js
import React, { useEffect } from 'react';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import { hydratePrinterSettingsFromElectronStore } from './utils/posPrinterSettings';
import { installFileLogger } from './utils/fileLogger';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { LanguageProvider } from './context/LanguageContext';
import { RestaurantProvider } from './context/RestaurantContext';
import { BranchProvider } from './context/BranchContext';
import { POSProvider } from './context/POSContext';
import AppRoutes from './routes/AppRoutes';
import OwnerAlertModal from './components/common/OwnerAlertModal';
import UpdateNotification from './components/common/UpdateNotification';
import { ErrorModalProvider } from './components/common/ErrorModal';
import RootErrorBoundary from './components/common/RootErrorBoundary';

// When running inside Electron the page is loaded via file://, which breaks
// BrowserRouter's history-based routing. HashRouter (#/path) works perfectly
// with file:// and is set transparently — no code changes needed elsewhere.
const Router = window.electronAPI?.isElectron ? HashRouter : BrowserRouter;

// Mirror renderer console + uncaught errors into the Electron daily log file.
// Runs once at module load so we capture early-boot logs too.
installFileLogger();

function App() {
  useEffect(() => {
    hydratePrinterSettingsFromElectronStore();
  }, []);

  return (
    <RootErrorBoundary>
    <Router>
      <LanguageProvider>
        <ThemeProvider>
          <AuthProvider>
            <ErrorModalProvider>
              <OwnerAlertModal />
              <UpdateNotification />
              <RestaurantProvider>
                <BranchProvider>
                  <POSProvider>
                    <AppRoutes />
                  </POSProvider>
                </BranchProvider>
              </RestaurantProvider>
            </ErrorModalProvider>
          </AuthProvider>
        </ThemeProvider>
      </LanguageProvider>
    </Router>
    </RootErrorBoundary>
  );
}

export default App;